import React from 'react'
import cx from 'classnames'
import { FormattedMessage } from 'sb-react-intl'

import Href from 'components/ui/Href/Href'
import Picture from 'components/ui/Picture/Picture'

import s from './HeaderNavItemTitle.scss'

// resolve picture x2
import lightningIcon from './images/lightningIcon.png'


const HeaderNavItemTitle = (props) => {
  const {
    children, title, uppercase, to, toOLD, redirect, className, withLightningIcon, onClick,
    dataTestId,
  } = props

  const rootClassName = cx(className, s.title, {
    [s.uppercase]: uppercase,
  })

  const commonProps = {
    className: rootClassName,
    onClick,
  }

  if (to || toOLD || redirect) {
    return (
      <Href
        {...commonProps}
        to={to}
        toOLD={toOLD}
        redirect={redirect}
        dataTestId={dataTestId}
        role="menuitem"
      >
        {children || <FormattedMessage {...title} />}
        {
          withLightningIcon && (
            <Picture className={s.icon} {...lightningIcon} />
          )
        }
      </Href>
    )
  }

  if (children) {
    return (
      <span data-testid={dataTestId} {...commonProps}>{children}</span>
    )
  }

  return (
    <FormattedMessage data-testid={dataTestId} {...commonProps} {...title} />
  )
}


export default HeaderNavItemTitle
